import { gql } from '@apollo/client'

export const UPDATE_ANALYTICS = gql`
  mutation updateAnalytics($source: String!, $payload: AnalyticsInput) {
    analytics: updateAnalytics(source: $source, payload: $payload) {
      id
    }
  }
`
